import styled from "styled-components"
import { device } from "../../../constants/breakpoints"
import img from "../../../images/filters.png"
import { CheckBoxContainer } from "../../AuthModal/AuthModal.styled"

export const Container = styled.div`
  background-color: #fff;
  box-shadow: 2px 2px 30px #efefef;
  padding: 20px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  max-width: 400px;

  @media ${device.laptop} {
    font-size: 14px !important;
  }

  @media ${device.tabletSm} {
    max-width: 1000px;
    width: 100%;
    margin: 0px;
    padding: 0px;

    box-shadow: none;
  }
`

export const FilterRowTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  border-bottom: 1px solid #efefef;
  padding-top: 15px;
  @media ${device.tabletSm} {
    border: 0;
    background: ${({ theme }) => theme.whitegray};
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 25px;
  }
`

export const FilterTitle = styled.div`
  font-weight: 400;
  color: ${({ theme }) => theme.darkblue};
  padding-left: 5px;
`

export const FilterButton = styled.div`
  cursor: pointer;
  background: #264a79;
  max-width: 80%;
  font-weight: 400;
  font-size: 14px;
  color: white;
  border-radius: 8px;
  margin: auto;
  padding: 7.5px;
  margin-top: 10px;
`

export const FilterButtonText = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.midblue};
  font-size: 13px;
  margin-top: 3px;

  margin-right: 5px;
  transition: 0.5s linear all;
  &::after {
    content: "Reset filtri";
  }

  @media ${device.tabletSm} {
    ${({ open }) =>
      !open &&
      `
  &::after {
    background-image: url(${img});
    background-size: 20px 20px;
    display: inline-block;
    width: 20px; 
    height: 20px;
    content:"";
  }
`}
  }
`

export const FilterFooter = styled.div`
  background: white;
  margin-top: 20px;
  height: 50px;
`

export const FilterInner = styled.div`
  padding-top: 30px;
  margin-left: 15px;
  @media ${device.tabletSm} {
    transition: all 0.5s ease-in-out;
    max-height: ${({ open }) => (open ? "500px" : "0px")};
    overflow: hidden;
    padding-top: 0px;
    margin-left: 35px;
  }
`

export const FilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: space-between;

  @media ${device.tabletSm} {
    font-size: 13px;
  }
`
export const FilterText = styled.div`
  margin-left: 0px;
  font-weight: 600;
`

export const FilterRowCheckBox = styled(FilterRow)`
  justify-content: flex-start;
  @media ${device.tablet} {
    & > div:nth-child(1) {
      margin-left: 0px;
    }
    & > div:nth-child(2) {
      margin-left: 15px;
    }
  }

  @media ${device.tabletSm} {
    & > div:nth-child(1) {
      margin-left: 0px;
    }
    & > div:nth-child(2) {
      margin-left: 25px;
    }
  }
`

export const FilterTextLabel = styled.div`
  font-weight: 600;
  margin-top: 5px;
`
export const FilterIndicator = styled.div`
  position: absolute;
  margin-top: -3px;
  margin-left: 14px;
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background: red;
`
